// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import Paper from '@material-ui/core/Paper';

import Navigation from '../../../common/Navigation/Navigation';
import { BasketPaperInfo } from '../components';
import styles from './styles';


class BasketPage extends React.Component {
  state = {};

  render() {
    const { classes } = this.props;
    return (
      <Navigation haveBlueRect>
        <div className={classes.mainContainer}>
          <MediaQuery minWidth={800}>
            {matches => (matches
              ? <Paper className={classes.mainPaper}><BasketPaperInfo /></Paper>
              : <BasketPaperInfo />)}
          </MediaQuery>
        </div>
      </Navigation>
    );
  }
}

BasketPage.propTypes = {
  classes: PropTypes.object,
};

BasketPage.defaultProps = {
  classes: {},
};

export default withStyles(styles)(BasketPage);
